import { AnimatePresence, motion } from 'framer-motion'
import type { FC } from 'react'
import { useRef, useEffect } from 'react'
import type { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/controller'
import { Navigation, EffectFade, Controller } from 'swiper/modules'
import { Swiper } from 'swiper/react'

import { IconArrow } from 'components/icons/arrow'
import { IconClose } from 'components/icons/close'
import type { dataType } from 'models'
import { modalDescriptionVariants } from 'styles/variants'

import {
  ModalGalleryCont,
  ModalInner,
  ModalHeader,
  ModalSlide,
  ModalNav,
  CloseButton,
  Description,
} from './styled'

type NavOpts = {
  prevEl?: HTMLElement | null
  nextEl?: HTMLElement | null
}

export const ModalGallery: FC<{
  readonly data: dataType[]
  readonly activeSlide: number
  readonly onClose: () => void
  //readonly onChange: (index: number) => void
  readonly parentSwiper: React.MutableRefObject<SwiperType | null>
}> = ({ data, activeSlide, onClose, parentSwiper }) => {
  const thumbsSwiperRef = useRef<SwiperType | null>(null)
  const swiperPrevRef = useRef(null)
  const swiperNextRef = useRef(null)
  const innerRef = useRef<HTMLDivElement>(null)
  const handleClose = () => {
    onClose()
  }
  useEffect(() => {
    if (thumbsSwiperRef.current && parentSwiper.current) {
      // Connect the two swipers
      parentSwiper.current.controller.control = thumbsSwiperRef.current
      thumbsSwiperRef.current.controller.control = parentSwiper.current
    }
  }, [parentSwiper])

  return (
    <ModalGalleryCont>
      <ModalInner ref={innerRef}>
        <ModalHeader>
          <CloseButton onClick={handleClose}>
            <IconClose />
          </CloseButton>
        </ModalHeader>
        <Swiper
          onSwiper={swiper => (thumbsSwiperRef.current = swiper)}
          initialSlide={activeSlide}
          autoHeight
          effect="fade"
          modules={[Navigation, EffectFade, Controller]}
          navigation={{
            prevEl: swiperPrevRef.current,
            nextEl: swiperNextRef.current,
          }}
          onBeforeInit={(swiper: SwiperType) => {
            const navigation = swiper.params.navigation as NavOpts
            navigation.prevEl = swiperPrevRef.current
            navigation.nextEl = swiperNextRef.current
          }}
        >
          {data.map((slide, index) => (
            <ModalSlide key={slide.id} $isActive={activeSlide === index}>
              <img alt="gallery" src={slide.img} />
            </ModalSlide>
          ))}
          <ModalNav ref={swiperPrevRef} $align="left">
            <IconArrow aria-label="Previous" />
          </ModalNav>
          <ModalNav ref={swiperNextRef} $align="right">
            <IconArrow aria-label="Next" />
          </ModalNav>
        </Swiper>
        {/*<Description>{data[activeSlide].text}</Description>*/}
        <Description>
          <AnimatePresence
            mode="popLayout"
            initial={false}
            presenceAffectsLayout
          >
            <motion.div
              key={activeSlide}
              variants={modalDescriptionVariants}
              initial="initial"
              animate="visible"
              exit="hidden"
            >
              {data[activeSlide].text}
            </motion.div>
          </AnimatePresence>
        </Description>
      </ModalInner>
    </ModalGalleryCont>
  )
}
